import  gql  from 'graphql-tag'

export const SHARE_ANALYSIS_EMAIL = gql`mutation shareCharacterAnalysisByEmail($input: ShareCharacterAnalysisByEmailMutationInput!){
    shareCharacterAnalysisByEmail(input: $input){
        errors{
            field
            messages
        }
    }
}`;